import React, { FC, ReactElement } from 'react';

import css from './style.module.scss';
import classNames from 'classnames';

interface IProps {
  children: ReactElement;
  className?: string;
}

const LoaderWrap: FC<IProps> = ({ children, className }) => (
  <div className={classNames(css.loaderWrap, className)}>{children}</div>
);

export default LoaderWrap;
